export * from './useGlobalCompanyTabs';
export { default as useGlobalCompanyTabs } from './useGlobalCompanyTabs';
